import { gql, useMutation, useQuery } from "@apollo/client";
import React from "react";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { Loading } from "../../../../components/Loading";
import { Graph } from "../../../../generated/graph";
import { Toast } from "../../../../hooks/toast";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "products", to: "#" },
  { text: "choice", to: "/product/choice/create" },
];

const QUERY_PRODUCT = gql`
  query supplierProductRequestList {
    supplierProductRequestList(
      offset: 0
      limit: 10000
      filter: { status: APPROVED, order: DESC, type: AVAILABLE }
    ) {
      data {
        content
      }
    }
  }
`;

const MUTATION_PRODUCT_CHOICE = gql`
mutation addProductChoice($itemid: Int!){
  addProductChoice(itemid: $itemid)
}
`;

export function CreateProductChoiceScreen() {
  const { data, loading } = useQuery<Graph.Query>(QUERY_PRODUCT, {
    fetchPolicy: "no-cache",
  });
  const [addProductChoice] = useMutation(MUTATION_PRODUCT_CHOICE, {
    onCompleted: res => {
      if(res.addProductChoice) {
        Toast.onShow('Request product choice success.', 'success', 'right');
      }
    },
    onError: err => {
      Toast.onShow(err.message, 'danger', 'right');
    }
  });

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <h5 className="mb-4">Create Product Choice</h5>
            <hr />
            <Loading />
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-5">
          <h5 className="mb-4">Request Product Choice</h5>
          <hr />
          <table className="table table-padded">
            <tbody>
              {data.supplierProductRequestList &&
                data.supplierProductRequestList.data
                  ?.filter(
                    (x) =>
                      x.content.stock > 0 &&
                      x.content.rating_score > 3 &&
                      x.content.l192_choice === 'F'
                  )
                  .map((item) => {
                    return (
                      <tr key={item.content.itemid!}>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                style={{
                                  width: 65,
                                  height: 65,
                                  borderRadius: 4,
                                  objectFit: "cover",
                                }}
                                src={item.content.thumb_mid}
                                alt=""
                              />
                              <div style={{ marginLeft: 10 }}>
                                <a href={"https://www.l192.com/product/" + item.content.itemid} target="_blank" rel="noopener noreferrer">L192: {item.content.code}</a>
                                <br/>
                                {[...new Array(item.content.rating_score)].map(
                                  () => {
                                    return (
                                      <i
                                        className="fa fa-star"
                                        style={{ color: "#fbc531" }}
                                      ></i>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                            <button 
                              className="btn btn-primary btn-sm"
                              onClick={()=>{
                                addProductChoice({
                                  variables: {
                                    itemid: Number(item.content.itemid)
                                  }
                                })
                              }}
                            >
                              Request
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>
        </div>
      </div>
    </Content>
  );
}
